import { UpdateTemplateContentUsingDiffOperation } from "@/store/sync/operations/templates/UpdateTemplateContentUsingDiffOperation";
import { SyncOperationGeneric } from "@/store/sync/operations/types";
import { orderBy } from "lodash-es";

export const getQueuedTemplateDocumentUpdates = ({
  operationsByModelId,
  id,
}: {
  operationsByModelId: Map<string, SyncOperationGeneric[]>;
  id: string;
}) => {
  const output: { id: string; encodedContentDiff: string; isDestructive?: boolean }[] = [];
  const pendingOperations = orderBy(
    operationsByModelId.get(id) || [],
    "locally_committed_at",
    "asc"
  );
  for (const operation of pendingOperations) {
    if (operation.operationKind !== "UPDATE_TEMPLATE_CONTENT_USING_DIFF") continue;
    const op = operation as UpdateTemplateContentUsingDiffOperation;
    if (op.payload.id !== id || op.payload.encoded_content_diff.length === 0) continue;
    output.push({ id: op.id, encodedContentDiff: op.payload.encoded_content_diff });
  }
  return output;
};
